import { render, staticRenderFns } from "./extract.vue?vue&type=template&id=06b82d6f"
import script from "./extract.vue?vue&type=script&lang=js"
export * from "./extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports